import React from 'react';
import { setVulnerabilityDetailTab } from 'store/Manage/actions';
import { selectVulnDetailSelectedTabContext } from 'store/Manage/selectors';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import useTabsShortcuts from 'Hooks/useTabsShortcuts';
import TABS from './tabs';
import { TabSelectorWrapper, TabButton } from './styled';

const Tabs = ({ scope }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const selectedTab = useSelector(selectVulnDetailSelectedTabContext);

  const getLabel = (tab) => intl.formatMessage({ id: tab.intlId });
  const isActive = (tab) => tab.id === selectedTab.id;

  useTabsShortcuts({
    tabs: TABS,
    activeId: selectedTab.id,
    onChange: (id) => dispatch(setVulnerabilityDetailTab(id)),
    scope
  });

  return (
    <TabSelectorWrapper>
      { TABS.map((tab) => (
        <TabButton
          active={ isActive(tab) }
          key={ tab.id }
          onClick={ () => dispatch(setVulnerabilityDetailTab(tab.id)) }
          children={ getLabel(tab) }
        />
      ))}
    </TabSelectorWrapper>
  );
};

export default Tabs;
